import styled from "styled-components";
import {
  BASIC_BLACK,
  BASIC_LINE,
  BASIC_ORANGE,
  BASIC_WHITE,
  BASIC_YELLOW,
} from "../../../constants/colors";
import { CouponGroupExternal } from "../../../ducks/coupon";
import { useAsset } from "../../../hooks/useAsset";
import { formatDateTime } from "../../../utils/date";
import { StyledCheckbox } from "../../atoms/Checkbox";

type Props = {
  couponGroup: CouponGroupExternal;
  isUsed: boolean;
  onSelect: () => void;
};

export const AppCouponGroup: React.FC<Props> = ({
  couponGroup,
  isUsed,
  onSelect,
}) => {
  const { baseDir } = useAsset();
  return (
    <CouponCard onClick={onSelect}>
      <CouponHeader $isUsed={isUsed}>
        <CouponImage
          src={
            couponGroup.imageUrl || baseDir + "/assets/images/menu_dummy@2x.jpg"
          }
          alt={couponGroup.name}
        />
        <CouponTextArea>
          <CheckboxWrapper $isUsed={isUsed}>
            <StyledCheckbox
              type="checkbox"
              checked
              readOnly
              $checkboxStyle="selection"
            />
          </CheckboxWrapper>
          <CouponTitle>{couponGroup.name}</CouponTitle>
        </CouponTextArea>
      </CouponHeader>

      <CouponFooter $isUsed={isUsed}>
        【有効期限】
        {formatDateTime(
          couponGroup.endAvailableDate,
          false,
          "YYYY/MM/DD HH:mm",
        )}
      </CouponFooter>
    </CouponCard>
  );
};

const CouponCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${BASIC_WHITE};
  box-sizing: border-box;
  cursor: pointer;
  margin: 10px;
`;

const CouponHeader = styled.div<{ $isUsed?: boolean }>`
  display: flex;
  border-top: 2px solid
    ${({ $isUsed }) => ($isUsed ? BASIC_ORANGE : BASIC_LINE)};
  border-left: 2px solid
    ${({ $isUsed }) => ($isUsed ? BASIC_ORANGE : BASIC_LINE)};
  border-right: 2px solid
    ${({ $isUsed }) => ($isUsed ? BASIC_ORANGE : BASIC_LINE)};
  gap: 20px;
  border-radius: 8px 8px 0 0;
`;

const CouponImage = styled.img`
  width: 87px;
  height: 64px;
  object-fit: cover;
  border-radius: 8px 0 0 0;
`;

const CouponTextArea = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  flex: 1;
`;

const CheckboxWrapper = styled.div<{ $isUsed?: boolean }>`
  position: absolute;
  top: 0;
  right: -12px;
  display: ${({ $isUsed }) => ($isUsed ? "block" : "none")};
`;

const CouponTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${BASIC_BLACK};
  line-height: 1.4;
`;

const CouponFooter = styled.div<{ $isUsed?: boolean }>`
  font-size: 10px;
  font-weight: 600;
  background-color: ${({ $isUsed }) => ($isUsed ? BASIC_ORANGE : BASIC_YELLOW)};
  border: 2px solid ${({ $isUsed }) => ($isUsed ? BASIC_ORANGE : BASIC_YELLOW)};
  color: ${BASIC_WHITE};
  text-align: center;
  padding: 0 8px;
  box-sizing: border-box;
  border-radius: 0 0 8px 8px;
`;
